import { render, staticRenderFns } from "./ManageEDSCriteria.vue?vue&type=template&id=82dfa1cc&"
import script from "./ManageEDSCriteria.vue?vue&type=script&lang=js&"
export * from "./ManageEDSCriteria.vue?vue&type=script&lang=js&"
import style0 from "./ManageEDSCriteria.vue?vue&type=style&index=0&id=82dfa1cc&prod&scopped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports